<app-menu>
  <div class="grid-header">
    <div class="grid-title">&nbsp;
      <i style="font-size: 30px;" class="fa-solid fa-person-falling"></i>&nbsp;&nbsp;Trip List
    </div>
    <div class="toolbar-actions">
      <div class="search-container">
        <button matTooltip="Go to Store Report"
                (click)="storeReports()"
                style="background-color: rgb(141, 8, 8);"
                mat-raised-button color="primary">
          <i style="font-size: 15px;" class="fas fa-house"></i>&nbsp;Store Report
        </button>&nbsp;
        <button matTooltip="Go to Exception Report"
                (click)="exceptionReports()"
                style="background-color: rgb(141, 8, 8);"
                mat-raised-button color="primary">
          <i style="font-size: 15px;" class="fas fa-check"></i>&nbsp;Exception Report
        </button>&nbsp;
        <button matTooltip="Go to Delivery Report"
                (click)="deliveryReports()"
                style="background-color: rgb(141, 8, 8);"
                mat-raised-button color="primary">
          <i style="font-size: 15px;" class="fas fa-truck"></i>&nbsp;Delivery Report
        </button>&nbsp;
        <button matTooltip="Upload ASN File"
                (click)="uploadAsnFile()"
                style="background-color: rgb(141, 8, 8);"
                mat-raised-button color="primary">
          <i style="font-size: 15px;" class="fas fa-upload"></i>&nbsp;Upload File
        </button>&nbsp;
        <button matTooltip="Upload Yoshino File"
                (click)="uploadYoshinoFile()"
                style="background-color: rgb(141, 8, 8);"
                mat-raised-button color="primary">
          <i style="font-size: 15px;" class="fas fa-upload"></i>&nbsp;Upload Yoshino File
        </button>&nbsp;        
      </div>
    </div>
  </div>

  <div class="trip-list-grid-wrapper">
    <ag-grid-angular
      class="ag-theme-alpine"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [animateRows]="true"
      [rowModelType]="'serverSide'"
      [cacheBlockSize]="100"
      (gridReady)="onGridReady($event)"
      [detailCellRenderer]="detailCellRenderer"
      [masterDetail]="true"
      [detailRowHeight]="350"
      [getContextMenuItems]="getContextMenuItems">
    </ag-grid-angular>
  </div>
</app-menu>
